import { createStore } from 'vuex'

import { user } from './user';
import { ref } from './ref';
import { officerConfig } from './officerConfig';
import { keycloak } from './keycloak';

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    officerConfig,
    ref,
    keycloak,
  }
})
